const G = "LOGGER";
export {
  G as LOGGER
};
